import React, { useEffect, useRef } from "react";
import NftAvatar from "./NftAvatar";

// 功能一：加密對話
const EncryptedChatPhone = ({ data }) => (
  <div className="feat-phone feat-phone-fixed">
    <div className="feat-phone-notch" />
    <div className="feat-phone-topbar">
      <svg width="7" height="12" viewBox="0 0 8 14" fill="none" stroke="#00d46a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 1L1 7l6 6"/></svg>
      <div className="feat-phone-contact">
        <NftAvatar id={1} size={32} />
        <div>
          <div className="feat-phone-name">{data.name}</div>
          <div className="feat-phone-status">{data.status}</div>
        </div>
      </div>
    </div>
    <div className="feat-phone-chat feat-phone-body">
      {data.messages.map((msg, i) => (
        <div className={`fp-msg ${msg.from === "me" ? "fp-me" : "fp-them"}`} key={i}>
          {msg.from !== "me" && <NftAvatar id={1} size={24} />}
          <div className={`fp-bubble ${msg.from === "me" ? "fp-green" : ""}`}>{msg.text}</div>
        </div>
      ))}
      <div className="fp-encrypt-tag">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        {data.tag}
      </div>
    </div>
    <div className="feat-phone-inputbar">
      <div className="fp-input-field">Message...</div>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#00d46a"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
    </div>
    <div className="feat-phone-bottom" />
  </div>
);

// 功能二：控制面板
const ControlPanelPhone = ({ data }) => {
  const s = data.items;
  return (
    <div className="feat-phone feat-phone-fixed">
      <div className="feat-phone-notch" />
      <div className="feat-phone-settings-header">
        <svg width="7" height="12" viewBox="0 0 8 14" fill="none" stroke="#00d46a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 1L1 7l6 6"/></svg>
        <span>{data.title}</span>
        <span />
      </div>
      <div className="feat-phone-settings feat-phone-body">
        <div className="fp-settings-group">
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              {s.encryptionKeys}
            </span>
            <span className="fp-badge">{s.verified}</span>
          </div>
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              {s.disappearing}
            </span>
            <span className="fp-toggle fp-toggle-on" />
          </div>
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              {s.onionRouting}
            </span>
            <span className="fp-toggle fp-toggle-on" />
          </div>
        </div>
        <div className="fp-settings-group">
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
              {s.notifications}
            </span>
            <span className="fp-toggle" />
          </div>
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
              {s.theme}
            </span>
            <span className="fp-setting-val">{s.themeVal}</span>
          </div>
        </div>
        <div className="fp-settings-group">
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
              {s.linkedDevices}
            </span>
            <span className="fp-setting-val">2</span>
          </div>
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              {s.screenLock}
            </span>
            <span className="fp-toggle fp-toggle-on" />
          </div>
          <div className="fp-setting">
            <span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              {s.recoveryEmail}
            </span>
            <span className="fp-badge">{s.set}</span>
          </div>
        </div>
      </div>
      <div className="feat-phone-bottom" />
    </div>
  );
};

// 功能三：群組聊天
const avatarColors = ["#00d46a", "#61F78D", "#A3FFBE"];
const GroupChatPhone = ({ data }) => (
  <div className="feat-phone feat-phone-fixed">
    <div className="feat-phone-notch" />
    <div className="feat-phone-topbar">
      <svg width="7" height="12" viewBox="0 0 8 14" fill="none" stroke="#00d46a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 1L1 7l6 6"/></svg>
      <div className="feat-phone-contact">
        <div className="fp-group-avatars">
          {data.messages.filter(m => m.from !== "me").slice(0, 3).map((m, i) => (
            <span className="fp-g-av-wrap" key={i}><NftAvatar id={i + 2} size={22} /></span>
          ))}
          <span className="fp-g-av fp-g-more">+97</span>
        </div>
        <div>
          <div className="feat-phone-name">{data.name}</div>
          <div className="feat-phone-status">{data.members}</div>
        </div>
      </div>
    </div>
    <div className="feat-phone-chat feat-phone-body">
      {data.messages.map((msg, i) => (
        msg.from === "me" ? (
          <div className="fp-msg fp-me" key={i}>
            <div className="fp-bubble fp-green">{msg.text}</div>
          </div>
        ) : (
          <div className="fp-msg fp-them" key={i}>
            <NftAvatar id={(i % 3) + 2} size={24} />
            <div>
              <div className="fp-sender" style={{color: msg.color || "#00d46a"}}>{msg.from}</div>
              <div className="fp-bubble">{msg.text}</div>
            </div>
          </div>
        )
      ))}
    </div>
    <div className="feat-phone-inputbar">
      <div className="fp-input-field">{data.inputPlaceholder}</div>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="#00d46a"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
    </div>
    <div className="feat-phone-bottom" />
  </div>
);

// 滾動顯示動畫 Hook
const useScrollReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
};

const phoneComponents = [EncryptedChatPhone, ControlPanelPhone, GroupChatPhone];
const phoneDataKeys = ["chat", "settings", "group"];

const FeatureItem = ({ feature, index, t }) => {
  const PhoneComp = phoneComponents[index];
  const phoneData = t.featurePhones[phoneDataKeys[index]];
  const ref = useScrollReveal();

  return (
    <section className="feature-section" ref={ref}>
      <div className={`feature-row ${index % 2 === 1 ? "reverse" : ""}`}>
        <div className="feature-text scroll-fade-text">
          <h2>{feature.title}</h2>
          <p>{feature.description}</p>
        </div>
        <div className="feature-image scroll-fade-phone">
          {PhoneComp && phoneData ? <PhoneComp data={phoneData} /> : null}
        </div>
      </div>
    </section>
  );
};

const FeatureSection = ({ t }) => {
  return (
    <div id="features">
      {t.features.map((feature, index) => (
        <FeatureItem key={index} feature={feature} index={index} t={t} />
      ))}
    </div>
  );
};

export default FeatureSection;
